import { ContainerModule } from '@evertel/di'
import { IdleTimerService } from './IdleTimerService'
import { AuthBroadcastService } from './AuthBroadcastService'
import { AppService } from './services/AppService'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(AppService).toSelf().inSingletonScope()
        m.bind(IdleTimerService).toSelf().inSingletonScope()
        m.bind(AuthBroadcastService).toSelf().inSingletonScope()
    })
]

export {
    DI_MODULES
}
